angular.module('ikeweb.repository').service('repositoryFactory', ['ParseRepository', 'qPromiseDecoratorService', 'promiseProgressDecoratorService', 'cacheDecoratorBuilder', 'userHashService', 'parseErrorDecoratorService',
    function(ParseRepository, qPromiseDecoratorService, promiseProgressDecoratorService, cacheDecoratorBuilder, userHashService, parseErrorDecoratorService) {

        var functionsToCache = ['get', 'list'];
        var functionsThatFlush = ['create', 'save', 'destroy'];
        var functionsToDecorate = functionsToCache.concat(functionsThatFlush);

        function addProgress(repository) {
            return promiseProgressDecoratorService.decorateDelegateWithProgress(repository, functionsToDecorate);
        }

        function addCaching(repository) {
            return cacheDecoratorBuilder
                .aCacheDecorator()
                .withTTL(moment.duration(1, 'minutes').asMilliseconds())
                .withHash(userHashService.hash)
                .build()
                .decorateDelegateWithCaching(repository, functionsToCache, functionsThatFlush);
        }

        function translateToQPromises(repository) {
            return qPromiseDecoratorService.decorateDelegateWithPromise(repository, functionsToDecorate);
        }

        function translateParseErrors(repository, overrides) {
            return parseErrorDecoratorService.decorateDelegatePromiseErrors(repository, functionsToDecorate, overrides);
        }

        function createRepository(className, objectFactory) {
            return new ParseRepository(className, objectFactory);
        }

        function create(className, objectFactory, errorOverrides) {
            return addProgress(addCaching(translateParseErrors(translateToQPromises(createRepository(className, objectFactory)), errorOverrides)));
        }

        return {
            create: create
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/repository/repository.factory.js
// module id = 447
// module chunks = 0